import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';

@Injectable()
export class TitleService {
  section = null;
  page = '';
  suffix = '';

  constructor(private titleService: Title, private translate: TranslateService) { }

  setTitle(page) {
    this.suffix = '';
    if (page) {
      this.section = page.section;
      this.page = page.page;

      this.titleService.setTitle(page.page ? 'Lina | ' + this.translate.instant(page.page) : 'Lina');
    } else {
      this.section = null;
      this.page = null;
    }
  }

  setSuffix(value) {
    this.suffix = value;
  }

  getTitle() {
    return {section: this.section, page: this.page, suffix: this.suffix};
  }

}
